import React from "react";
import NavigationBar from "../common/NavigationBar";
import logo from "../../assets/img/youl-systems-logo.svg";

export default function ManagementHeader() {
  return (
    <div className="py-4 lg:py-[30px] flex items-center justify-between">
      <img src={logo} alt="" className="w-[110px]" />
      <NavigationBar />
    </div>
  );
}
